import { useState } from "react";
import { PageHero } from "@/components/PageHero";
import { MapPin, Phone, EnvelopeSimple, WhatsappLogo, PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import { COMMITTEE, SOCIETY } from "@/lib/data";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all the fields.");
      return;
    }
    toast.success("Message received! The management will reach out soon.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div data-testid="contact-page">
      <PageHero
        overline="Contact"
        title={
          <>
            Let&apos;s
            <span className="italic text-brand-gold"> talk.</span>
          </>
        }
        lead="Reach out to the management office, a committee member, or simply drop us a note."
        image="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80"
      />

      <section className="py-24 md:py-32 px-6 md:px-10">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Contact info */}
          <div className="lg:col-span-5 space-y-10">
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-brand-leaf font-semibold mb-3">
                Management Office
              </div>
              <div className="space-y-4">
                <a href={SOCIETY.mapsUrl} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-brand-ink hover:text-brand-leaf transition-colors" data-testid="contact-map">
                  <MapPin size={20} weight="light" className="mt-1 shrink-0 text-brand-gold" />
                  <span className="leading-relaxed">
                    Konappana Agrahara,<br />Electronic City, Bengaluru — 560100
                  </span>
                </a>
                <a href="tel:+918000000000" className="flex items-center gap-3 text-brand-ink hover:text-brand-leaf transition-colors" data-testid="contact-phone">
                  <Phone size={20} weight="light" className="text-brand-gold" /> +91 80 0000 0000
                </a>
                <a href="mailto:hello@itowersexente.in" className="flex items-center gap-3 text-brand-ink hover:text-brand-leaf transition-colors" data-testid="contact-email">
                  <EnvelopeSimple size={20} weight="light" className="text-brand-gold" /> hello@itowersexente.in
                </a>
                <a href="https://wa.me/918000000000" className="flex items-center gap-3 text-brand-ink hover:text-brand-leaf transition-colors" data-testid="contact-whatsapp">
                  <WhatsappLogo size={20} weight="light" className="text-brand-gold" /> WhatsApp the management
                </a>
              </div>
            </div>

            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-brand-leaf font-semibold mb-5">
                Management Committee
              </div>
              <div className="grid grid-cols-2 gap-3">
                {COMMITTEE.map((m, i) => (
                  <div key={m.name} data-testid={`committee-${i}`} className="p-4 rounded-xl bg-brand-sage/40 border border-brand-sage">
                    <div className="font-display text-lg text-brand-forest">{m.name}</div>
                    <div className="text-xs text-brand-mute">{m.role}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={onSubmit} data-testid="contact-form" className="lg:col-span-7 bg-brand-sage/40 rounded-2xl p-8 md:p-12">
            <h2 className="font-display text-3xl md:text-4xl text-brand-forest">Send a message</h2>
            <p className="text-brand-mute mt-2 mb-8">Vendor inquiry, feedback, or just saying hello — we read every note.</p>
            <div className="space-y-5">
              <div>
                <label className="block text-xs uppercase tracking-[0.2em] text-brand-leaf font-semibold mb-2">Your name</label>
                <input
                  type="text"
                  data-testid="contact-name-input"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full px-4 py-3 bg-brand-ivory rounded-lg border border-brand-sage focus:border-brand-leaf focus:outline-none transition-colors"
                  placeholder="Anita Rao"
                />
              </div>
              <div>
                <label className="block text-xs uppercase tracking-[0.2em] text-brand-leaf font-semibold mb-2">Email</label>
                <input
                  type="email"
                  data-testid="contact-email-input"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full px-4 py-3 bg-brand-ivory rounded-lg border border-brand-sage focus:border-brand-leaf focus:outline-none transition-colors"
                  placeholder="anita@example.com"
                />
              </div>
              <div>
                <label className="block text-xs uppercase tracking-[0.2em] text-brand-leaf font-semibold mb-2">Message</label>
                <textarea
                  rows={5}
                  data-testid="contact-message-input"
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  className="w-full px-4 py-3 bg-brand-ivory rounded-lg border border-brand-sage focus:border-brand-leaf focus:outline-none transition-colors resize-none"
                  placeholder="Tell us a bit about your inquiry..."
                />
              </div>
              <button
                type="submit"
                data-testid="contact-submit-btn"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-brand-forest text-brand-ivory font-medium hover:bg-brand-leaf transition-colors"
              >
                Send message <PaperPlaneTilt size={16} weight="light" />
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;
